import CategoryGroupList from './CategoryGroup'

export default CategoryGroupList
